module.exports = __webpack_public_path__ + "static/key-yookalaylee-33359a9e2d06784564fd6950653f5801.webp";